Wee.fn.make('share', {
	init: function() {
		this.$private.initEvents();
	},

	unload: function() {
		$.events.off(false, '.share');
	}
}, {
	initEvents: function() {
		$.events.on({
			'ref:share': {
				click: function() {
					var $this = $(this);

					$this.isActive() ? $this.deactivate() : $this.activate();
				}
			},

			'ref:shareLink': {
				mouseenter: function(e, el) {
					$(el).activate();
				},
				mouseleave: function(e, el) {
					$(el).deactivate();
				}
			}
		}, {
			namespace: 'share'
		});
	}
});